<template>
  <div class="container">
    <content-header :data="[{text:'上报一览', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <!--div class="search-entry">
            <el-input
              placeholder="请输入关键字"
              v-model="keywords">
            </el-input>
        </div-->
        <div class="search-entry">
          <span>上报日期</span>
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="dateChange"
            :picker-options="datePickerOptions">
          </el-date-picker>
        </div>
        <div class="search-btn">
          <el-button type="primary" @click="searchHandle">查询</el-button>
        </div>
        <div class="search-btn">
          <el-button type="primary" @click="exportHandle">导出</el-button>
        </div>
      </div>
      <!-- 列表区域 -->
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe>
          <el-table-column
            fixed
            prop="number"
            label="编号"
            width="100">
          </el-table-column>
          <el-table-column
            prop="category_text"
            label="分类">
          </el-table-column>
          <el-table-column
            prop="causer_type_text"
            label="事故发生人类型">
          </el-table-column>
          <el-table-column
            prop="causer_name"
            label="事故发生人姓名">
          </el-table-column>
          <el-table-column
            prop="type_text"
            label="事故类型">
          </el-table-column>
          <el-table-column
            prop="accident_date"
            label="发生日期">
          </el-table-column>
          <el-table-column
            prop="date_type_text"
            label="时间归属">
          </el-table-column>
          <el-table-column
            prop="description"
            label="描述">
          </el-table-column>
          <el-table-column
            prop="action_plan"
            label="计划">
          </el-table-column>
          <el-table-column
            prop="suggestion"
            label="建议"
            width="200">
          </el-table-column>
          <el-table-column
            label="图片">
            <template slot-scope="scope">
              <el-popover
              v-for="(item, index) in scope.row.photo_arr"
              :key="index"
               placement="right"
               title=""
               trigger="hover">
               <img :src="item" style="max-height: 600px;max-width: 800px" />
               <img slot="reference" :src="item" style="max-height: 50px;max-width: 130px">
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="sharing_date"
            label="分享时间">
          </el-table-column>
          <el-table-column
            prop="sharing_scene"
            label="分享场景">
          </el-table-column>
          <el-table-column
            prop="sharing_record"
            label="分享记录"
            width="240">
          </el-table-column>
          <el-table-column
            prop="created"
            label="上报日期">
          </el-table-column>
          <el-table-column
            prop="user_name"
            label="上报人姓名">
          </el-table-column>
          <el-table-column
            prop="mobile"
            label="上报人手机">
          </el-table-column>
          <el-table-column
            prop="comment"
            label="处理意见">
          </el-table-column>
          <el-table-column
            prop="modified"
            label="处理日期">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="100">
            <template slot-scope="scope">
              <el-button @click="initCheckHandle(scope)" type="text" size="small">反馈处理</el-button>
              <!--el-button @click="deleteHandle(scope)" type="text" size="small">删除</el-button-->
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="total > curSize">
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="curPageChange"
            :current-page="curPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="curSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
      <!-- 新建弹出区域 -->
      <div class="new-wrap">
        <el-dialog title="填写处理意见" :visible.sync="isObjShow">
          <el-form :model="curObj" :rules="curObjRules" ref="curObjForm" label-position="right" label-width="0px">
            <el-form-item prop="comment" label="处理意见" :label-width="formLabelWidth">
              <el-input type="textarea" name="comment" v-model="curObj.comment" auto-complete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="isObjShow = false">取 消</el-button>
            <el-button type="primary" @click="confirmHandle">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import ReportModel from 'models/report'

  export default {
    data () {
      return {
        keywords: '',
        tableData: [],
        curPage: 1,
        curSize: 10,
        total: 0,
        startDate: '',
        endDate: '',
        dateRange: '',
        datePickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        isObjShow: false,
        formLabelWidth: '120px',
        curObj: {
          id: '',
          comment: ''
        },
        curObjRules: {
          comment: [{ required: true, message: '请填写处理意见', trigger: 'blur' }],
        },
      }
    },
    created () {
      this.getObjList()
    },
    methods: {
      pageSizeChange (size) {
        this.curSize = size
        this.getObjList()
      },
      curPageChange (page) {
        this.curPage = page
        this.getObjList()
      },
      getObjList (opts) {
        const _opts = {
          curPage: this.curPage,
          pageSize: this.curSize,
          keywords: this.keywords,
          startDate: this.startDate,
          endDate: this.endDate
        }
        // 合并参数
        if (typeof opts === 'object') Object.assign(_opts, opts)
        //
        ReportModel.find(_opts).then(res => {
          this.tableData = res.item_list
          this.total = res.total
        })
      },
      deleteHandle (item) {
        this.$confirm('确认删除？')
          .then(_ => {
            ReportModel.delete({
              id: item.row.id,
            }).then(() => {
              this.getObjList()
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(_ => {
              this.$message({ message: '删除失败', type: 'error' })
            })
          })
          .catch(_ => {})
      },
      searchHandle () {
        this.getObjList()
      },
      exportHandle () {
        const _opts = {
          keywords: this.keywords,
          startDate: this.startDate,
          endDate: this.endDate
        }
        ReportModel.export(_opts)
      },
      dateChange (value) {
        if (value) {
          this.startDate = value[0]
          this.endDate = value[1]
        } else {
          this.startDate = ''
          this.endDate = ''
        }
      },
      confirmHandle () {
        this.$refs.curObjForm.validate(valid => {
          if (!valid) return
          ReportModel.updateComment(this.curObj).then(() => {
            this.getObjList()
            this.isObjShow = false
            this.$message({ message: '更新成功', type: 'success' })
          }).catch(err => {
            this.$message({ message: err.message, type: 'error' })
          })
        })
      },
      initCheckHandle (item) {
        this.curObj = {
          id: item.row.id,
          comment: item.row.comment
        }
        this.isObjShow = true
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
      .search-entry
        display: inline-block
        vertical-align: top
        margin-right: 20px
        span
          display: inline-block
          vertical-align: top
          line-height: 36px
        .entry-box
          display: inline-block
          vertical-align: top
          width: 140px
          &.username
            width: 140px
      .search-btn
        display: inline-block
        vertical-align: top
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
      .pagination
        margin-top: 10px
    .new-wrap
      .el-input
        width: 300px
</style>



// WEBPACK FOOTER //
// src/views/Report.vue